import { render } from "./ClaimRewardModal.vue?vue&type=template&id=6de0f0ca"
import script from "./ClaimRewardModal.vue?vue&type=script&lang=js"
export * from "./ClaimRewardModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__